import type { IconProps } from "@/types/icon";

const CheckIcon12 = ({
    width = 12,
    height = 10,
    fill = "#F2F2F2",
    ...remainingProps
}: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 10"
            fill="none"
            {...remainingProps}
        >
            <path
                d="M4.34555 9.04998L0.498047 5.20248L1.45992 4.2406L4.34555 7.12623L10.5387 0.933105L11.5005 1.89498L4.34555 9.04998Z"
                fill={fill}
            />
        </svg>
    );
};

export default CheckIcon12;
